export const MAP_ACCESS_TOKEN = "pk.eyJ1IjoidGhhbWluYWRzIiwiYSI6ImNsN2RqNWhiejFuZ2UzdW9sMHpsdjRyOWYifQ.USED-Oe45xQJQ24zYiD7Hg";
// export const baseURL =  "https://dev.thmin.com/api/v1.1.1/";
// export const pusherAuthUrl = "https://dev.thmin.com/api/v1.1.1/pusher/auth";

// export const baseURL =  "http://thamin.test/api/v1.1.1/";
export const baseURL =  "https://thmin.com/api/v1.1.1/";
export const pusherAuthUrl = "https://thmin.com/api/v1.1.1/pusher/auth";